import { DEFAULT_CHART_GRID_BOTTOM } from '../constants';
import { ChartECOption } from '../types';

export interface GetChartGridOptionArgs {
  overrides?: Partial<ChartECOption['grid']>;
}

export function getChartGridOption({ overrides }: GetChartGridOptionArgs): ChartECOption['grid'] {
  return { bottom: DEFAULT_CHART_GRID_BOTTOM, left: 4, right: 4, top: 0, containLabel: true, ...overrides };
}
